import React from 'react';
import type { Reader } from './types';
import { bestFor, formatPrice } from './catalog';

// Import Card from @coupling/ui so the alias resolution works for all sites
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Card } from '@coupling/ui';

const screenOf = (r: Reader) => (r.specs?.display ? String(r.specs.display).split(',')[0] : 'No screen');
const batteryOf = (r: Reader) => (r.battery ? (r.specs?.battery ? String(r.specs.battery).split(';')[1]?.trim() || 'Yes' : 'Yes') : 'No (wired power)');

export const ReaderComparisonTable: React.FC<{ readers: Reader[] }> = ({ readers }) => (
  <Card padding="none" className="overflow-x-auto">
    <table className="w-full min-w-[720px] text-left text-sm">
      <caption className="sr-only">Stripe reader comparison</caption>
      <thead className="bg-neutral-50 text-neutral-600">
        <tr>
          {['Reader', 'Price', 'Screen', 'Battery', 'Connectivity', 'Offline mode', 'Best for'].map((h) => (
            <th key={h} scope="col" className="px-4 py-3 font-semibold">{h}</th>
          ))}
        </tr>
      </thead>
      <tbody className="divide-y divide-neutral-200">
        {readers.map((r) => (
          <tr key={r.id}>
            <th scope="row" className="px-4 py-3 font-semibold text-neutral-900">
              <a href={`#${r.id}`} className="hover:underline">{r.name}</a>
            </th>
            {/* TODO(#2289): Stripe US list price; Coupling merchant pricing is not decided. */}
            <td className="px-4 py-3">{formatPrice(r.price_cents)}</td>
            <td className="px-4 py-3">{screenOf(r)}</td>
            <td className="px-4 py-3">{batteryOf(r)}</td>
            <td className="px-4 py-3">{r.connectivity.join(', ')}</td>
            <td className="px-4 py-3">{r.offline_mode ? 'Yes' : 'Not listed'}</td>
            <td className="px-4 py-3">{bestFor(r)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </Card>
);
